module.exports = __webpack_public_path__ + "videos/hero_jp.0a4f79a.mp4";